import { render, staticRenderFns } from "./component-d7bb860f.vue?vue&type=template&id=2f3856b8&scoped=true&"
import script from "./component-d7bb860f.vue?vue&type=script&lang=js&"
export * from "./component-d7bb860f.vue?vue&type=script&lang=js&"
import style0 from "./component-d7bb860f.vue?vue&type=style&index=0&id=2f3856b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3856b8",
  null
  
)

export default component.exports